var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rr-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"show-rows-count":8,"more-btn-text-active":"more awards","more-btn-text-non-active":"less awards"}})}
var staticRenderFns = []

export { render, staticRenderFns }